import { Model, useRepo } from "pinia-orm";
import Answer from "@/socio-questionnaire/models/Answer";
import Category from "@/socio-questionnaire/models/Category";
import Questionnaire from "@/socio-questionnaire/models/Questionnaire";

export default class Question extends Model {
  static entity = "questions";

  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      createdAt: this.attr(null),
      updatedAt: this.attr(null),
      content: this.string(),
      order: this.attr(null),
      indeterminate: this.boolean(false),
      info: this.string(),
      comment: this.string(),
      extraData: this.attr(null),
      objectRelatedUuids: this.attr([]),
      parent: this.attr(null),
      children: this.hasMany(Question, "parent"),
      answer: this.hasOne(Answer, "question"),
      categoryUuid: this.attr(null),
    };
  }

  static insertOrUpdateAnswer(question, value, indeterminate, projectId) {
    // Update the question field indeterminate and
    // if answer exists, update it else create it
    useRepo(Question).save({
      uuid: question.uuid,
      indeterminate: !!indeterminate,
      answer: {
        uuid: question.answer?.uuid ?? null,
        value,
        question: question.uuid,
        objectRelatedId: projectId,
      },
    });
  }

  static getFirstParentQuestion(question) {
    let parentQuestion = question;

    while (!parentQuestion.categoryUuid && parentQuestion.parent) {
      parentQuestion = useRepo(Question).find(parentQuestion.parent);
    }
    return parentQuestion;
  }

  static getQuestionnaire(question) {
    const categoryRepo = useRepo(Category);
    const questionnaireRepo = useRepo(Questionnaire);
    const parentQuestion = this.getFirstParentQuestion(question);
    const category = categoryRepo.find(parentQuestion.categoryUuid);
    const questionnaire = questionnaireRepo.find(category?.questionnaireUuid);
    return questionnaire;
  }
}
